import React from 'react';
import { Box, Grid, Typography, Button, Link, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// Import your logo image
import Logo from '../../../assets/Logo/kl.webp'; // Replace with your logo path

export default function Footer() {
  return (
    <Box sx={{ backgroundColor: '#000', color: '#fff', padding: '40px 0' }}>
      <Grid container spacing={4} justifyContent="center">
        
        {/* Logo and Contact Section */}
        <Grid item xs={12} md={3} textAlign="center">
          <Box mb={2}>
            <img src={Logo} alt="KALEIDO International" style={{ width: '120px' }} />
          </Box>
          <Typography variant="h6" fontWeight={700}>KALEIDO INTERNATIONAL</Typography>
          <Button
            variant="contained"
            sx={{
              backgroundColor: '#0067ff',
              color: '#fff',
              mt: 2,
              '&:hover': {
                backgroundColor: '#0055cc',
              }
            }}
          >
            Contact
          </Button>
          <Box mt={2}>
            <IconButton sx={{ color: '#fff' }}>
              <EmailIcon />
            </IconButton>
            <IconButton sx={{ color: '#fff' }}>
              <FacebookIcon />
            </IconButton>
            <IconButton sx={{ color: '#fff' }}>
              <InstagramIcon />
            </IconButton>
            <IconButton sx={{ color: '#fff' }}>
              <WhatsAppIcon />
            </IconButton>
          </Box>
        </Grid>
        
        {/* Menu Sections */}
        <Grid item xs={12} md={3} textAlign="center">
          <Typography variant="h6" fontWeight={700}>Home</Typography>
          <Box mt={2}>
            <Link href="#" underline="none" color="inherit" display="block" mb={1}>
              About Us
            </Link>
            <Link href="#" underline="none" color="inherit" display="block">
              Blogs
            </Link>
          </Box>
        </Grid>

        <Grid item xs={12} md={3} textAlign="center">
          <Typography variant="h6" fontWeight={700}>Our Services</Typography>
          <Box mt={2}>
            <Link href="#" underline="none" color="inherit" display="block" mb={1}>
              Budgeting
            </Link>
            <Link href="#" underline="none" color="inherit" display="block" mb={1}>
              Bookkeeping
            </Link>
            <Link href="#" underline="none" color="inherit" display="block" mb={1}>
              Accounting
            </Link>
            <Link href="#" underline="none" color="inherit" display="block">
              Tax Consultation
            </Link>
          </Box>
        </Grid>

        <Grid item xs={12} md={3} textAlign="center">
          <Typography variant="h6" fontWeight={700}>Policy</Typography>
          <Box mt={2}>
            <Link href="#" underline="none" color="inherit" display="block">
              Privacy Terms
            </Link>
          </Box>
        </Grid>

        {/* Copyright Section */}
        <Grid item xs={12} textAlign="center" mt={4}>
          <Typography variant="body2" color="inherit">
            © {new Date().getFullYear()} KALEIDO International. All rights reserved.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
